import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-setting-report",
  "use": "icon-user-setting-report-usage",
  "viewBox": "0 0 31 30",
  "content": "<symbol viewBox=\"0 0 31 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user-setting-report\">\r\n  <path d=\"M27.9593 25.8835H2.8457V4.03906H5.35707V23.4563H7.86843V12.5341H12.8912V23.4563H15.4025V7.6798H20.4252V23.4563H22.9366V17.3884H27.9593V25.8835Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol